import { CHOOSE, FIXED_PERCENTAGE } from "../core-modules/constants";

import Box from "./Box";
import Divider from "./Divider";
import PropTypes from "prop-types";
import React from "react";
import Stack from "./Stack";
import Text from "./Text";
import UnderlineButton from "./UnderlineButton";
import _ from "lodash";
import { getTakebackValue } from "../core-modules/utils";
import { useAppContext } from "./AppContext";
import { useBrand } from "./BrandContext";
import { withTheme } from "styled-components";

const fontSizes = [16, 16, 20, 22];

function Item({ item, quantity }) {
  return (
    <Box display="flex" justifyContent="space-between">
      <Box>
        <Text fontSize={fontSizes}>
          {item.name}
          {quantity > 1 && ` x ${quantity}`}
        </Text>
      </Box>
    </Box>
  );
}

Item.propTypes = {
  item: PropTypes.shape({ name: PropTypes.string.isRequired }),
  quantity: PropTypes.number.isRequired,
};

function TakebackSummary({ theme, style, itemsEditable, items, donations }) {
  const { setCurrentStep } = useAppContext();
  const brand = useBrand();

  let itemsByCategory = _.groupBy(items, "category.name");
  if (donations.length > 0) {
    itemsByCategory["Donations"] = donations;
  }

  const groupItemsByName = (items) => {
    const itemsByName = _.groupBy(items, "name");
    return Object.keys(itemsByName).map((itemName) => {
      const item = items.find((item) => {
        return item.name === itemName;
      });
      return (
        <Item
          key={item.id}
          item={item}
          quantity={itemsByName[itemName].length}
        />
      );
    });
  };

  return (
    <Box style={style} display="flex" flexDirection="column">
      <Box
        py={[20, null, 30, 40]}
        px={20}
        display="flex"
        justifyContent="center"
        alignItems="center"
        backgroundColor="foreground"
        flexShrink={0}
      >
        <Text
          fontWeight={700}
          fontFamily="bold"
          fontSize={fontSizes}
          uppercase
          color="background"
          textAlign="center"
        >
          Your trade-in items
        </Text>
      </Box>
      <Box
        borderWidth="2px"
        borderStyle="solid"
        borderColor={theme.colors.offForeground}
        borderTop="none"
        p={[20, null, 30, 40]}
        flex={1}
        overflowY="auto"
      >
        {Object.keys(itemsByCategory).length === 1 ? (
          <Stack divider={<Divider />}>{groupItemsByName(items)}</Stack>
        ) : (
          <Stack divider={<Divider />}>
            {Object.keys(itemsByCategory).map((category) => {
              const items = itemsByCategory[category];
              return (
                <React.Fragment key={category}>
                  <Text fontSize={fontSizes} key={category} pb={20} uppercase>
                    {category}
                  </Text>
                  <Stack itemBoxProps={{ pb: "10px", pt: 0 }}>
                    {groupItemsByName(items)}
                  </Stack>
                </React.Fragment>
              );
            })}
          </Stack>
        )}

        <Box display="flex" justifyContent="space-between" pt={40}>
          <Text fontSize={fontSizes}>
            {brand.incentiveType === FIXED_PERCENTAGE ? "Discount" : "Value"}
          </Text>
          <Text fontSize={fontSizes}>{getTakebackValue(brand, items)}</Text>
        </Box>
        {itemsEditable && (
          <Box display="flex" justifyContent="center" pt={30}>
            <UnderlineButton
              onClick={() => {
                setCurrentStep(CHOOSE);
              }}
            >
              Edit
            </UnderlineButton>
          </Box>
        )}
      </Box>
    </Box>
  );
}

TakebackSummary.propTypes = {
  itemsEditable: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      category: PropTypes.shape({ name: PropTypes.string.isRequired })
        .isRequired,
      value: PropTypes.number,
    })
  ),
};

export default withTheme(TakebackSummary);
